module.exports = __webpack_public_path__ + "img/qqth2.be0a1d73.jpg";